import { OctagonAlertIcon } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const AdditionalInfoBanner = ({
  title = "Additional information required",
  message = "Review the request and submit the required information",
  buttonText = "Review request",
  actionPath = "/onboarding/update-information",
  onAction,
  className = "",
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (onAction) {
      onAction();
    } else if (actionPath) {
      navigate(actionPath);
    }
  };

  return (
    <div
      style={{ borderBottom: "1px solid #FDB022" }}
      className={`w-full bg-[#FFF9F2] px-3 md:px-6 py-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 ${className}`}
    >
      <div className="flex items-center gap-x-3">
        {/* Octagon Alert Icon */}
        <div className="shrink-0 flex items-center justify-center">
          <OctagonAlertIcon color="#C05621" size={22} />
        </div>

        {/* Text Content */}
        <div className="flex flex-wrap items-center gap-x-2 text-sm">
          <span className="font-semibold text-[#93360D]">{title}</span>
          <span className="text-[#45556C]">{message}</span>
        </div>
      </div>

      {/* Action Button */}
      <button
        onClick={handleAction}
        className="shrink-0 bg-[#0B0F19] hover:bg-slate-800 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors cursor-pointer"
      >
        {buttonText}
      </button>
    </div>
  );
};

export default AdditionalInfoBanner;
